import { render, staticRenderFns } from "./SDialogSelectProductComp.vue?vue&type=template&id=2151234e&"
import script from "./SDialogSelectProductComp.vue?vue&type=script&lang=js&"
export * from "./SDialogSelectProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports